
import { Component, Injector, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import { Dashboard } from '../dashboard/dashboard';
import { UserLogin } from '../user-login/user-login';
import { UserForgotpassword } from '../user-forgotpassword/user-forgotpassword';
import { Util } from '../../app/util';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
var docsrc = '';

@IonicPage()
@Component({
  selector: 'page-user-signup',
  templateUrl: 'user-signup.html',
})
export class UserSignup extends Util {
  private captchaPassed: boolean = false;
  private captchaResponse: string;
  photoName: string = '';
  fileExtension: any;
  fileExtensionError: boolean;
  fileExtensionMessage: string = '';
  err: string;
  showtoken: boolean;
  token: string = '';
  params: any = { nome: '', cognome: '', email: '', username: '', password: '', rpassword: '', data_nascita: '', azienda: '', area: '', filiale: '', ruolo: '', privacy: false, cf: '', token: '' };
  constructor(public navCtrl: NavController, public theme: EthemeProvider,public translate: TranslateService, public navParams: NavParams, injector: Injector, private zone: NgZone, loading: LoadingController) {
    super(injector, loading);
    this.showtoken = false;
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UserSignup');
  }

  captchaResolved(response: string): void {

    this.zone.run(() => {
      this.captchaPassed = true;
      this.captchaResponse = response;
    });

  }
  dashboardPage() { this.navCtrl.push(Dashboard); }
  loginPage() { this.navCtrl.push(UserLogin); }
  forgotPasswordPage() { this.navCtrl.push(UserForgotpassword); }
  have_token() {
    this.showtoken = !this.showtoken;
  }
  onChange(f) {
    //console.log(f);
    var file = f[0];
    this.photoName = file.name;

    var allowedExtensions =
      ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];
    this.fileExtension = this.photoName.split('.').pop();

    if (allowedExtensions.indexOf(this.fileExtension) != -1) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = "";
    } else {
      this.fileExtensionMessage = "- Sono ammesse solo immagini con estensioni jpg o png";
      this.fileExtensionError = true;
    }


    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(f[0]);
      reader.onload = function () {
        //console.log(reader.result);
        docsrc = reader.result;
      };
      reader.onerror = function (error) {
        //console.log('Error: ', error);
      };
    }
    else {
      alert("Failed to load file");
    }
  }

  signup() {

    this.translate.get(['ERRORE',
      'registrazione.MODULO',
      'registrazione.INS_NOME',
      'registrazione.SUCCESSO',
      "registrazione.INS_COGNOME",
      "registrazione.INS_USERNAME",
      "registrazione.INS_EMAIL",
      "registrazione.INS_PASSWORD",
      "registrazione.INS_RIPASSWORD",
      "registrazione.INS_DATANASCITA",
      "registrazione.DIFFPASS",
      "registrazione.ERR_PRIVACY",
      "registrazione.INS_TOKEN",
      "registrazione.INS_FILIALE"
    ]).subscribe(v => {
      this.err = '';
      if (this.params.nome == '')
        this.err += '- ' +v['registrazione.INS_NOME']+'<br>';
      if (this.params.cognome == '')
        this.err += '- ' +v['registrazione.INS_COGNOME']+'<br>';
      if (this.params.username == '')
        this.err += '- ' +v['registrazione.INS_USERNAME']+'<br>';
      if (this.params.email == '')
        this.err += '- ' +v['registrazione.INS_EMAIL']+'<br>';
      if (this.params.password == '')
        this.err += '- ' +v['registrazione.INS_PASSWORD']+'<br>';
      if (this.params.rpassword == '')
        this.err += '- ' +v['registrazione.INS_RIPASSWORD']+'<br>';
      if (this.params.rpassword != this.params.password)
        this.err += '- ' +v['registrazione.DIFFPASS']+'<br>';
      // if (this.params.data_nascita == '')
      //   this.err += '- ' +v['registrazione.INS_DATANASCITA']+'<br>';
      if (this.params.privacy == false) {
        this.err += '- ' +v['registrazione.ERR_PRIVACY']+'<br>';
      }
      if(this.theme.theme_selected == 'yamamay-theme'){
        if (this.params.filiale == '') {
          this.err += '- ' +v['registrazione.INS_FILIALE']+'<br>';
        }
        if (this.token == '') {
          this.err += '- ' +v['registrazione.INS_TOKEN']+'<br>';
        }
        
      }

      /*else {
        if (docsrc == '') {
          this.err += '- Devi caricare la foto di un documento di identità<br>';
        }
        if (this.fileExtensionMessage != '') {
          this.err += this.fileExtensionMessage + '<br>';
        }
      }*/
      /*if (this.params.privacy == false) {
        this.err += '- Non hai accettato l\'informativa sulla Privacy e le consizioni di utilizzo<br>';
      }*/
      /*if (this.captchaPassed == false) {
        this.err += '- Non hai dichiarato di non essere un robot<br>';
      }*/


      if (this.err == '') {

        this.params.token = this.token;
        this.PostRequest('signup', '', this.params, true, true).then((data: any) => {

          this.showBasicAlert(v['registrazione.MODULO'], v['registrazione.SUCCESSO']);

          if (this.showtoken && this.token != '')
            this.send_token(data.Utente.id);
          /*this.PostRequest('logout', null, null).then(data => {
          }).catch(err => {
            console.error(err);
          });*/
          //this.storage.clear();
          this.navCtrl.push(UserLogin);
          //window.location.reload();
        }).catch(err => {
          console.error(err);
          //this.showBasicAlert('Errore',err)
        });
      }
      else {
        this.showBasicAlert(v['ERRORE'], this.err);
      }
    })
  }
  termini_condizioni() {
    // this.navCtrl.push(TermsPage);
    this.open_in_app_browser('http://www.skilleyd.net/site/gdpr/');
  }

  send_token(idutente) {
    this.PostRequest('attivaTokenUtente', idutente + '/' + this.token, {}, true, true).then((res: any) => {
      this.showBasicAlert('Token', res.message);
      //console.log(res);
    }).catch((err) => {
      console.error(err);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-signup/user-signup.ts